export const isRequired = (
  value: string | null,
  message: string = 'This field is required',
): boolean | string => !!value || message;
